import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Song } from 'src/shared/models/song.model';
import { SongService } from 'src/shared/services/song.service';

@Component({
  selector: 'app-verse',
  templateUrl: './verse.component.html',
  styleUrls: ['./verse.component.scss']
})
export class VerseComponent implements OnInit, OnDestroy {
  public song: Song;
  private routeChange$: Subscription;

  constructor(private songService: SongService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.routeChange$ = this.route.params.subscribe(params => {
      this.song = this.songService.GetByHandle(params['handle']);
    });
  }

  ngOnDestroy(): void {
    if (!!this.routeChange$ && !this.routeChange$.closed) this.routeChange$.unsubscribe();
  }

}
